import React, { Component } from 'react';
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavbarToggler,
  Collapse
} from 'reactstrap'
import SVGInline from "react-svg-inline"
import HeaderLink from '../HeaderLink/HeaderLink'

import styles from './PrivateHeader.css'
import LogoSVG from '../../assets/img/logo.svg?raw'
import { color_logo_blue } from "../../constants/colors";
import Button from "../Button/Button";

export default class PrivateHeader extends Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <div className={[styles.header, styles.scrolled].join(' ')}>
        <Navbar className={styles.headerNavbar} color="light" light expand="md">
          <NavbarBrand href="/">
            <div className={styles.logoWrapper}>
              <SVGInline svg={LogoSVG} height="48px" width="246px" />
              <span className={styles.subtitle} style={{ color: color_logo_blue }}>Arzttermine Kurzfristig. Einfach. Schnell.</span>
            </div>
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav navbar className={[styles.navbarNav, "ml-auto"].join(' ')}>
              <NavItem>
                <HeaderLink
                  to="/dashboard"
                  label="Ärztebereich"
                  activeOnlyWhenExact={true}
                />
              </NavItem>
              <NavItem>
                <HeaderLink
                  to="/dashboard/profile"
                  label="Mein Profil"
                />
              </NavItem>
              <NavItem>
                <HeaderLink
                  to="/dashboard/settings"
                  label="Einstellungen"
                />
              </NavItem>
              <NavItem className={styles.flexItem}>
                <Button
                  href="/"
                  onClick={() => {
                    localStorage.removeItem('authToken');
                    window.location.href = "/";
                  }}
                  activeOnlyWhenExact={true}
                  label="Logout"
                >
                  Logout
                </Button>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PrivateHeader/PrivateHeader.js